<script lang="ts">
  type Props = {
    color?: string
  }

  let { color = 'var(--grid-stroke)' }: Props = $props()
</script>

<div
  style={`--color: ${color}`}
  class="color"
></div>

<style lang="scss">
  .color {
    align-self: stretch;
    border-top: 1px solid var(--color);
    display: flex;
    height: 1px;
  }
</style>
